import apiService from '@/core/common/services/api.service';

export const GET_GESPEICHERTE_FILTER = 'gespeicherteFilter.getGespeicherteFilter';
export const CREATE_GESPEICHERTER_FILTER = 'gespeicherteFilter.createGespeicherterFilter';
export const DELETE_GESPEICHERTER_FILTER = 'gespeicherteFilter.deleteGespeicherterFilter';

// Gespeicherte Filter des angemeldeten Users je Übersicht (bereich, z. B. 'Aufgabenuebersicht').
// Core speichert den Filterinhalt als JSON-String, den nur der Manager auswertet.
const parseFilter = gespeicherterFilter => ({
  ...gespeicherterFilter,
  filter: JSON.parse(gespeicherterFilter.filter),
});

const actions = {
  [GET_GESPEICHERTE_FILTER](context, { bereich }) {
    return apiService
      .get('/GespeicherteFilter', `?bereich=${encodeURIComponent(bereich)}`)
      .then(response => (response.data.result.value ?? []).map(parseFilter));
  },
  [CREATE_GESPEICHERTER_FILTER](context, { bereich, name, filter, automatischAnwenden }) {
    return apiService
      .post('/GespeicherteFilter', {
        bereich,
        name,
        filter: JSON.stringify(filter),
        automatischAnwenden,
      })
      .then(response => parseFilter(response.data.result.value));
  },
  [DELETE_GESPEICHERTER_FILTER](context, { id }) {
    return apiService.delete(`/GespeicherteFilter/${id}`);
  },
};

export default {
  actions,
};
